import { render } from "solid-js/web"
import { Router, Route, Navigate } from "@solidjs/router"
import { Layout } from "./components/Layout"
import { SchedulePage } from "./pages/SchedulePage"
import { WorkersPage } from "./pages/WorkersPage"
import { StoresPage } from "./pages/StoresPage"
import { PrintPage } from "./pages/PrintPage"
import { AuthProvider } from "./lib/auth"

const root = document.getElementById("root")

if (root === null) {
  throw new Error("Root element not found")
}

render(() => (
  <AuthProvider>
    <Router>
      <Route path="/print/schedule/:workplaceId/:month" component={PrintPage} />
      
      <Route path="/" component={Layout}>
        <Route path="/" component={() => <Navigate href="/schedule" />} />
        <Route path="/schedule" component={SchedulePage} />
        <Route path="/schedule/:workplaceId" component={SchedulePage} />
        <Route path="/schedule/:workplaceId/:month" component={SchedulePage} />
        <Route path="/workers" component={WorkersPage} />
        <Route path="/workers/:workplaceId" component={WorkersPage} />
        <Route path="/stores" component={StoresPage} />
      </Route>
    </Router>
  </AuthProvider>
), root)
